import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePageWithBody } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/sla")({
  loader: async () => {
    const page = await loadStandalonePageWithBody({ data: { path: "sla.md" } });
    return {
      title: (page.title as string) || "SLA",
      robots: page.robots as string | undefined,
      html: page.html as string,
    };
  },
  head: ({ loaderData }) => ({ meta: seo({ title: loaderData?.title || "SLA", url: "/sla", noindex: loaderData?.robots === "noindex" }),
    links: seoLinks({ url: "/sla" }), }),
  component: () => {
    const { title, html } = Route.useLoaderData();
    return (
      <article className="mx-auto max-w-3xl px-4 py-16 md:px-8">
        <h1 className="mb-8 text-4xl font-bold text-charcoal">{title}</h1>
        <div className="content" dangerouslySetInnerHTML={{ __html: html }} />
      </article>
    );
  },
});
